$(function () {
    $('[data-input-autoselect]').each(function () {
        var self = $(this);
        self.on('click', function (e) {
            self.select()
        })
    });
})
